export const firebaseConfig = {
    apiKey: "AIzaSyBL0P_D7X5WUZAnIee29F4Pt28rJabOYjk",
    authDomain: "pennywise-c7e3f.firebaseapp.com",
    projectId: "pennywise-c7e3f",
    storageBucket: "pennywise-c7e3f.appspot.com",
    messagingSenderId: "96840204912",
    appId: "1:96840204912:web:824ff703f892398aa16ab5",
    measurementId: "G-0Q8CWY45DD"
};